"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cashback = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../../hooks");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const Cashback = ({
  cashback
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  if (!cashback) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Chip, {
      "data-testid": getTestId(_constants.CASHBACK),
      color: "offer",
      variant: "tag",
      size: "small",
      label: formatMessage('priceCashback', {
        price: cashback
      })
    })
  });
};
exports.Cashback = Cashback;
//# sourceMappingURL=Cashback.js.map